// Shared P1 gamification constants. Centralized so the rules referenced in
// the P1 Completion Report have exactly one source of truth in code.
export const DEFAULT_PASSING_THRESHOLD_PERCENT = 80
export const XP_PER_QUIZ_PASS = 100
export const FOUNDATIONS_CERTIFICATE_COURSE_NAME = 'CyberTales Learning — Foundations Track'
export const FOUNDATIONS_TRACK_EPISODE_IDS = [
  'ep-phishing-trap',
  'ep-simswap-shadows',
  'ep-password-fortress',
]

// P4 gamification XP amounts. Deliberately smaller than XP_PER_QUIZ_PASS
// (100) — passing a quiz demonstrates mastery, these reward engagement and
// practice, per the P4 instruction to reinforce learning behavior rather
// than hand out points everywhere.
export const XP_PER_EPISODE_COMPLETE = 20
export const XP_PER_SCENARIO_COMPLETE = 25
export const XP_PER_STORY_COMPLETE = 75
export const XP_PER_ESCAPE_ROOM_COMPLETE = 150
export const XP_PER_STREAK_MILESTONE = 50
